import { useRef } from "react";

export default function QRControls({ settings, setSettings }) {
  const fileInputRef = useRef();

  const handleLogoUpload = (file) => {
    if (!file) return;

    const reader = new FileReader();
    reader.onload = () => {
      setSettings((prev) => ({
        ...prev,
        logo: reader.result,
      }));
    };
    reader.readAsDataURL(file);
  };

  return (
    <div className="bg-white/[0.03] border border-white/[0.08] rounded-2xl p-5 space-y-6 backdrop-blur-sm">

      {/* 🔝 HEADER */}
      <div>
        <p className="text-xs text-white/60 uppercase tracking-widest">
          Customize Design
        </p>
        <p className="text-xs text-white/30 mt-1">
          Adjust branding & colors
        </p>
      </div>

      {/* 🏷 BUSINESS NAME */}
      <div>
        <label className="text-[11px] text-white/40">
          Business Name
        </label>

        <input
          type="text"
          placeholder="e.g. Gopalas Veg Kitchen"
          value={settings.businessName}
          onChange={(e) =>
            setSettings((prev) => ({
              ...prev,
              businessName: e.target.value,
            }))
          }
          className="mt-2 w-full px-3 py-2.5 bg-white/[0.04] border border-white/[0.08] rounded-lg text-sm text-white placeholder-white/30 focus:border-white/30 outline-none transition"
        />
      </div>

      {/* 🎨 COLORS */}
      <div className="space-y-5">

        {/* QR COLOR */}
        <div className="flex items-center justify-between">
          <div>
            <p className="text-xs text-white/50">QR Color</p>
            <p className="text-[10px] text-white/25">
              Foreground
            </p>
          </div>

          <div className="flex flex-col items-center">
            <input
              type="color"
              value={settings.qrColor}
              onChange={(e) =>
                setSettings((prev) => ({
                  ...prev,
                  qrColor: e.target.value,
                }))
              }
              className="w-9 h-9 rounded-md border border-white/[0.15] bg-transparent cursor-pointer"
            />

            <span className="text-[10px] text-white/40 mt-1 tracking-wide">
              {settings.qrColor}
            </span>
          </div>
        </div>

        {/* BACKGROUND COLOR */}
        <div className="flex items-center justify-between">
          <div>
            <p className="text-xs text-white/50">Background</p>
            <p className="text-[10px] text-white/25">
              QR background
            </p>
          </div>

          <div className="flex flex-col items-center">
            <input
              type="color"
              value={settings.bgColor}
              onChange={(e) =>
                setSettings((prev) => ({
                  ...prev,
                  bgColor: e.target.value,
                }))
              }
              className="w-9 h-9 rounded-md border border-white/[0.15] bg-transparent cursor-pointer"
            />

            <span className="text-[10px] text-white/40 mt-1 tracking-wide">
              {settings.bgColor}
            </span>
          </div>
        </div>

      </div>

      {/* 🖼 LOGO UPLOAD */}
      <div>
        <label className="text-[11px] text-white/40">
          Business Logo
        </label>

        <div
          onClick={() => fileInputRef.current.click()}
          className="mt-2 border border-dashed border-white/[0.15] rounded-xl p-5 text-center cursor-pointer hover:border-white/30 hover:bg-white/[0.03] transition"
        >
          {settings.logo ? (
            <div className="flex flex-col items-center gap-2">
              <div className="w-12 h-12 rounded-lg bg-white/[0.04] border border-white/[0.08] flex items-center justify-center">
                <img
                  src={settings.logo}
                  alt="logo"
                  className="w-8 h-8 object-contain"
                />
              </div>

              <p className="text-[10px] text-white/40">
                Click to replace
              </p>
            </div>
          ) : (
            <div className="space-y-1">
              <p className="text-sm text-white/60">
                Upload logo
              </p>
              <p className="text-[10px] text-white/30">
                PNG or JPG recommended
              </p>
            </div>
          )}
        </div>

        <input
          type="file"
          accept="image/*"
          ref={fileInputRef}
          className="hidden"
          onChange={(e) => handleLogoUpload(e.target.files[0])}
        />
      </div>

    </div>
  );
}